import cn from "../../lib/classnames";
import React from "react";
import styles from "./RoundedCard.module.css";

type Props = {
    children: React.ReactNode;
    showBorder?: boolean;
    className?: string;
};

export default function RoundedCard(props: Props) {
    return (
        <div
            className={cn(
                styles.container,
                props.showBorder ? styles.border : undefined,
                props.className,
            )}
        >
            {props.children}
        </div>
    );
}
